import React from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';

import { TooltipInfoRow } from 'components/common/bryntumScheduler/components/tooltips/Components/TooltipInfoRow/TooltipInfoRow';
import { TooltipSection } from 'components/common/bryntumScheduler/components/tooltips/Components/TooltipSection/TooltipSection';
import { SummaryTooltipProps } from 'components/common/bryntumScheduler/components/tooltips/types';

export const SummaryTooltipData = ({ data }: SummaryTooltipProps) => {
    const { startDate, endDate } = data;
    const { spi, baselineStartDate, baselineEndDate, percentDone, plannedPercentDone } = data.eventRecord.originalData;
    return (
        <>
            <TooltipSection subTitle={'Summary bar info:'}>
                <TooltipInfoRow
                    label={'Start Date'}
                    value={startDate ? moment.utc(startDate).format(constants.formats.date.default) : undefined}
                />

                <TooltipInfoRow
                    label={'Finish Date'}
                    value={endDate ? moment.utc(endDate).format(constants.formats.date.default) : undefined}
                />

                <TooltipInfoRow
                    label={'Baseline Start Date'}
                    value={
                        baselineStartDate
                            ? moment.utc(baselineStartDate).format(constants.formats.date.default)
                            : undefined
                    }
                />
                <TooltipInfoRow
                    label={'Baseline Finish Date'}
                    value={
                        baselineEndDate ? moment.utc(baselineEndDate).format(constants.formats.date.default) : undefined
                    }
                />
            </TooltipSection>

            <TooltipSection
                subTitle={'Activity performance:'}
                subTitleInfo={'(based on activities captured in the summary bar)'}
            >
                <TooltipInfoRow label={'SPI'} value={spi?.toString()} />
                <TooltipInfoRow label={'Planned % Complete'} value={plannedPercentDone?.toString()} />
                <TooltipInfoRow label={'Actual % Complete'} value={percentDone?.toString()} />
            </TooltipSection>
        </>
    );
};
